import { BrowserRouter as Router } from "react-router-dom";
import useUser from "./pages/Login/useUser";
import Sidebar from "./components/Sidebar/Sidebar";
import Topbar from "./components/Topbar/Topbar";
import Footer from "./components/Footer/Footer";
import IdleTimer from "./components/IdleTimer/IdleTimer";
import Protected from "./routes/Protected";
import Private from "./routes/Private";
import Public from "./routes/Public";
import './assets/scss/fonts.scss';
import './App.css';
import { IconHome, IconMessageCircle, IconFileInvoice, IconClipboardText, IconZoomQuestion } from "@tabler/icons";
import RouteChangeTracker from "./components/GoogleAnalytics/RouteChangeTracker";
import ReactGA from 'react-ga';
import CookieBot from 'react-cookiebot';

const links = [
  { link: "Inicio", icon: <IconHome size={32} stroke={1.3} />, path: "/score" },
  { link: "Solicitud eGrade", icon: <IconZoomQuestion size={30} stroke={1.3} />, path: "/search" },
  { link: "Mis solicitudes", icon: < IconClipboardText size={30} stroke={1.3} />, path: "/request" },
  { link: "Facturas", icon: <IconFileInvoice size={30} stroke={1.3} />, path: "/bills" },
  { link: "Contacto", icon: <IconMessageCircle size={30} stroke={1.3} />, path: "/contact" }
];

function App() {
  const { user, setUser } = useUser();
  const TRACKING_ID = process.env.REACT_APP_GOOGLE_ANALYTICS; // YOUR_OWN_TRACKING_ID
  const TRACKING_COOKIE_BOT = process.env.REACT_APP_COOKIE_BOT_ENV; // COOKIE_BOT CODE
  ReactGA.initialize(TRACKING_ID);
  return (
    <div>
      <IdleTimer auth={user} timeOutInterval={1800000} />
      <CookieBot domainGroupId={TRACKING_COOKIE_BOT} />
      <Router>
        <RouteChangeTracker />
        <Protected user={user} setUser={setUser} publicRoutes={Public}>
          <div className="App">
            <Topbar />
            <Sidebar links={links}>
              <div className="pt-5">{<Private />}</div>
            </Sidebar>
            <Footer />
          </div>
        </Protected>
      </Router>
    </div>
  );
}

export default App;
